module.exports = __webpack_public_path__ + "img/sacde-sa.556845c4.jpg";